export default __webpack_public_path__ + "static/blue-car-mobile-ce1db5113897ab37bc64128dfa4f297d.png";